import { ContentEditableInput, TextSubHeader } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from './ErrorMessage';
import { CharactersCounter, FormField } from './FormField';
import { ruleNameSchema } from './schema';

const fieldName = 'name';
const maxChars = ruleNameSchema([])
  .describe()
  .tests.find((constraint) => constraint.name === 'max')?.params?.max as number;

export const RuleNameTitleField = () => {
  const {
    register,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(fieldName);
  const state = errors[fieldName] ? 'error' : 'normal';

  return (
    <div className="flex flex-col mr-10">
      <FormField name={fieldName}>
        <input
          {...register(fieldName)}
          hidden
        />
        <ContentEditableInput
          state={state}
          inputSize="md"
          onChange={(value) => {
            setValue(fieldName, value, {
              shouldDirty: true,
            });
            trigger(fieldName);
          }}
        >
          <div
            className={classNames(
              'truncate max-w-[880px] h-ds-md-input flex items-center',
              state === 'error' &&
                'border-ds-danger-400 rounded-md border px-2.5 py-1'
            )}
          >
            <TextSubHeader
              color="text-ds-natural-700"
              label={value}
              ellipsis
            />
          </div>
        </ContentEditableInput>
        <div className="flex leading-ds-200">
          <ErrorMessage
            name={fieldName}
            errors={errors}
          />
          <div className="ml-auto">
            <CharactersCounter
              current={value?.length}
              max={maxChars}
            />
          </div>
        </div>
      </FormField>
    </div>
  );
};
